import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AccountService } from '../../services/AccountService';
import { DealActionEnum, ApproverDealEnum } from '../../common/constants';
import { DealService } from '../../services/DealService';
import { AlertService } from '../../services/AlertService';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-deal-detail',
  templateUrl: './deal-detail.component.html',
  styleUrls: ['./deal-detail.component.scss']
})
export class DealDetailComponent implements OnInit {
    isAdmin: boolean = false;
    deal: any;
    approveSteps: any;
    acceptCount: number = 0;
    isProposingDirector: boolean = false;
    isRecipient: boolean = false;
    isReceivingDirector: boolean = false;
    isEditable: boolean = false;
    currentUser: any;
    showPropose: boolean = false;
    dealStatuses: string[] = ['Saved', 'Draft', 'Proposed', 'Accepted', 'Closed', 'Deleted'];
    constructor(private breadcrumbService: AppBreadcrumbService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private dealService: DealService,
        private alertService: AlertService,
        private confirmationService: ConfirmationService,) { }
    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
            this.isAdmin = this.accountService.IsAdmin;
            //this.isAdmin = false;
            this.deal = this.activatedRoute.snapshot.data['deal'];
            this.breadcrumbService.setItems([
                this.breadcrumbService.deal,
                { label: this.deal.Id, routerLink: [] }
            ]);

            this.approveSteps = [
                { label: 'Proposing Business Director' },
                { label: 'Recipient' },
                { label: 'Receiving Business Director' }
            ];         
            this.currentUser = this.accountService.userValue;
            if (this.currentUser.broker.Id == this.deal.ProposingManagerID)
                this.isProposingDirector = true;
            if (this.currentUser.broker.Id == this.deal.ReceivingUserID)
                this.isRecipient = true;
            if (this.currentUser.broker.Id == this.deal.ReceivingManagerID)
                this.isReceivingDirector = true;
            if (this.deal.ProposingUserID == this.currentUser.broker.Id && this.deal.DealStatusID == 1) {
                this.showPropose = true;
            }
            this.isEditable = this.accountService.CanEditDeal(this.deal.ProposingUserID, this.deal.ProposingManagerID, this.deal.ReceivingUserID, this.deal.ReceivingManagerID, this.deal.ProposingMemberID, this.deal.ReceivingMemberID);
        });            
    }

    getAcceptCount() {
        this.acceptCount = 0;
        if (this.deal.ProposingAcceptDeal) {
            this.acceptCount++;
        }
        if (this.deal.ReceivingBrokerAccept) {
            this.acceptCount++;
        }
        if (this.deal.ReceivingAcceptDeal) {
            this.acceptCount++;
        }

        return this.acceptCount;
    }

    showAccept(): boolean {
        if (this.deal.DealStatusID == 2) {
            if ((this.isProposingDirector && this.deal.ProposingAcceptDeal !== true)
                || (this.isRecipient && this.deal.ReceivingBrokerAccept !== true)
                || (this.isReceivingDirector && this.deal.ReceivingAcceptDeal !== true)) {
                return true;
            }
        }
        return false;
    }

    navToUserProfile(Id) {
        this.router.navigate(['/user/' + Id]);
    }

    acceptDeal() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to accept this deal?',
            accept: () => {
                if (this.isProposingDirector) { this.deal.ProposingAcceptDeal = true; }
                if (this.isRecipient) { this.deal.ReceivingBrokerAccept = true; }
                if (this.isReceivingDirector) { this.deal.ReceivingAcceptDeal = true; }
                this.deal.NewActionID = DealActionEnum.Update;
                this.callServiceToAcceptDeal();
            }
        });                     
    }

    callServiceToAcceptDeal() {
        this.dealService.AcceptDeal(this.deal).subscribe(
            result => {
                if (result.Id != null) {
                    this.deal = result;
                    this.alertService.SetMessage('success', 'Deal accepted');
                }
                else {
                    if (this.isProposingDirector) { this.deal.ProposingAcceptDeal = false; }
                    if (this.isRecipient) { this.deal.ReceivingBrokerAccept = false; }
                    if (this.isReceivingDirector) { this.deal.ReceivingAcceptDeal = false; }
                    this.alertService.SetMessage('error', 'There is an error while accepting deal');
                }
            },
            error => {
                if (this.isProposingDirector) { this.deal.ProposingAcceptDeal = false; }
                if (this.isRecipient) { this.deal.ReceivingBrokerAccept = false; }
                if (this.isReceivingDirector) { this.deal.ReceivingAcceptDeal = false; }
                this.alertService.SetMessage('error', 'There is an error while accepting deal');
            }
        );
    }

    adminAccept(approver: ApproverDealEnum) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to accept this deal?',
            accept: () => {
                switch (approver) {
                    case ApproverDealEnum.ProposingBusinessDirector: {
                        this.deal.ProposingAcceptDeal = true;
                        this.deal.NewActionID = DealActionEnum.Update;
                        this.callServiceToAcceptDeal();
                        break;
                    }
                    case ApproverDealEnum.Recipient: {
                        this.deal.ReceivingBrokerAccept = true;
                        this.deal.NewActionID = DealActionEnum.Update;
                        this.callServiceToAcceptDeal();
                        break;
                    }
                    case ApproverDealEnum.ReceivingBusinessDirector: {
                        this.deal.ReceivingAcceptDeal = true;
                        this.deal.NewActionID = DealActionEnum.Update;
                        this.callServiceToAcceptDeal();
                        break;
                    }
                } 
            }
        });                
    }
}
